import React from "../../_snowpack/pkg/react.js";
import {Card, CardBody} from "../../_snowpack/pkg/@patternfly/react-core.js";
import "./flow-title.css";
export const FlowTitle = ({title}) => {
  return /* @__PURE__ */ React.createElement(Card, {
    "data-testid": title,
    className: "keycloak__authentication__title",
    isFlat: true
  }, /* @__PURE__ */ React.createElement(CardBody, null, title));
};
